<template>
    <div class="row">
        <div class="col-12">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="white-text">
                <el-breadcrumb-item :to="{ name: 'website' }" class="white-text">Event Details</el-breadcrumb-item>
                <el-breadcrumb-item class="white-text">Select Registration Type</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <br> <br> 

        <div class="col-12">
            <div class="d-flex align-items-center mb-4 "><img :src="`${baseUrl}${event.logo.path}`" width="92px" height="92px" class="avatar-img"><h3 class="m-0 ml-3 white-text">{{event.name}}</h3></div>
        </div>
        <div class="col-12">
            <p class="text-center white-text">Click on your choice below</p>
        </div>

        <div class="col-md-12" v-for="group in formsGroupBy">
            <div class="field-set-block" style="background-color: rgba(255, 255, 255, 0.3); border:none; border-radius: 7px; padding:30px;">
                <div style="text-align: left;">
                    <h3 class="group-name bg-primary" style="color:#fff; border-radius: 5px; display: inline; padding: 10px; ">{{group.name}}</h3>
                </div>
                <div class="type-wrapper mt-4" >
                    <div v-for="type in group.types"
                    v-if="(user._id === event.creator) || (type.publicRegistration && !type.typeGroupOnly)"
                    :key="`registration-type-${type._id}`"
                    class="" style="width: 100%;">
                        <div :class="event.showTypeDescription ? 'type-card' : ''" >
                            <el-button class="btn btn-round"
                                style="margin-bottom: 10px; background-color: #1d8cd1 !important; color: #fff !important; text-align:center !important; white-space:normal !important; font-weight:600 !important; width:100% !important"
                                @click="select(type)">
                                    <div>
                                        <router-link :to="{ name: 'website-register', params: { typeId: type._id, typeName: type.name } }">
                                            <span class="type-clickable" style="color: white !important;">{{ type.name }}</span>
                                    </router-link>
                                    </div>
                            </el-button>
                        
                            <div v-if="event.showTypeDescription" class="mt-2" v-html="type.description"></div>
                        </div>

                        <!--card
                        @click="select(type)"
                        class="cursor-pointer">
                            <div class="d-flex justify-content-between align-items-center">
                                <router-link :to="{ name: 'website-register', params: { typeId: type._id, typeName: type.name } }">
                                    <span class="type-clickable">{{ type.name }}</span>

                                </router-link>
                            </div>
                        </card-->
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 text-center">
            <el-button
                class="btn btn-primary btn-round"
                @click="confirmationViewRequestDialog = true">
                    <span v-if="!user._id  && event.hideAllPaymentInfoFromRegistrant">View Status</span>
                    <span v-else>Make Payment / View Status</span>
            </el-button>
            <el-button v-if="event.showEditMyRegistration"
                class="btn btn-primary btn-round"
                @click="editRegistrationDialog = true">
                    Edit My Registration
            </el-button>
        </div>

        <!-- <div
            v-for="type in $store.state.types"
            v-if="(user._id === event.creator) || (type.publicRegistration && !type.typeGroupOnly)"
            :key="`registration-type-${type._id}`"
            class="col-md-4 mt-3">
                <card
                    @click="select(type)"
                    class="cursor-pointer">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{ type.name }}</span>
                        <router-link :to="{ name: 'website-register', params: { typeId: type._id, typeName: type.name } }">
                            <el-button type="text">
                                Choose
                            </el-button>
                        </router-link>
                    </div>
                </card>
        </div> -->

        <el-dialog
            title="Make Payment / View Status"
            :visible.sync="confirmationViewRequestDialog">
                <el-form @submit.prevent.native>
                    <el-form-item label="Confirmation Number">
                        <el-input v-model="viewConfirmation.number"/>
                    </el-form-item>
                    <el-form-item label="First Name">
                        <el-input v-model="viewConfirmation.firstName"/>
                    </el-form-item>
                    <el-form-item label="Last Name">
                        <el-input v-model="viewConfirmation.lastName"/>
                    </el-form-item>
                </el-form>
                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="viewRequest"
                        @click="submitConfirmationForCheck()">
                            Proceed
                    </el-button>
                </div>
        </el-dialog>

        <el-dialog
            title="Edit My Registration"
            :visible.sync="editRegistrationDialog">
                <el-form @submit.prevent.native>
                    <el-form-item
                        label="E-Mail">
                            <el-input
                                type="email"
                                v-model="editRegistrationEmail"
                                @keyup.enter.native="getEditRegistrationLink"/>
                    </el-form-item>
                    <el-form-item
                        label="Confirmation Number">
                            <el-input
                                v-model="editRegistrationId"
                                @keyup.enter.native="getEditRegistrationLink"/>
                    </el-form-item>
                    <p class="text-center font-weight-bold font"
                            style="font-size: 12px; color:red">
                                Link to Edit your Registration will be sent to the e-mail id provided.
                    </p>
                    <div class="ql-editor" v-if="event.showEditRegistrationRequestInfo" v-html="event.editRegistrationRequestInfo"></div>
                </el-form>
                <template slot="footer">
                    <el-button
                        type="primary"
                        @click="getEditRegistrationLink()"
                        :loading="sendingLink">
                            Proceed
                    </el-button>
                </template>
        </el-dialog>
        
    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data(){
        return {
            typeGroups: [],
            types: [],
            formsGroupBy: [],
            editRegistrationDialog: false,
            confirmationViewRequestDialog: false,
            editRegistrationEmail: '',
            editRegistrationId: '',
            viewRequest: false,
            viewConfirmation: {
                _id: '',
                firstName: '',
                lastName: ''
            },
            sendingLink: false,
        }
    },
    computed: {
        ...mapState([
            'event',
            'user',
            'baseUrl'
        ])
    },
    mounted(){
        this.getTypeGroups()
        //populate email-confirmation_no
        if(this.$route.query.email && this.$route.query.confno){
            this.editRegistrationDialog = true;
            this.editRegistrationEmail = this.$route.query.email
            this.editRegistrationId = this.$route.query.confno
        }
    },
    methods: {
        select: function (type) {
            this.$router.push({ name: 'website-register', params: { typeId: type._id, typeName: type.name } })
        },
        getTypeGroups: async function () {
            try {
                //get all registration type group
                this.typeGroups = await this.$store.dispatch('getAll', {
                    path: 'type-groups',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
                this.typeGroups = this.typeGroups.data.typeGroups
                //get all registration type form
                this.types = await this.$store.dispatch('getAll', {
                    path: 'types',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
                this.types = this.types.data.types

                this.formsGroupBy = this.typeGroups.map(group=>{//group loop

                    let types = this.types.filter(type=>{ //type loop
                        if(group.types.includes(type._id)){
                            return type
                        }
                    })

                    types = types.sort((a,b) => {
                        const order1 = Number(a.order) || Infinity; // Set to Infinity if "order" is not present
                        const order2 = Number(b.order) || Infinity; // Set to Infinity if "order" is not present

                        return order1 - order2;
                    })

                    return {name: group.name, order: group.order, types}

                }).filter(group=>group.types.length?group:null)

                this.formsGroupBy.sort((a,b) => {
                    const order1 = Number(a.order) || Infinity; // Set to Infinity if "order" is not present
                    const order2 = Number(b.order) || Infinity; // Set to Infinity if "order" is not present

                    return order1 - order2;
                })

                //console.log('@@this.typeGroups', this.typeGroups, this.types, this.formsGroupBy)
            } catch (e) {
                console.log('erorr getting fields', e)
            }
        },
        submitConfirmationForCheck: async function () {
            try {
                const response = await http.get(`/api/registrations/with-confirmation-number/${this.viewConfirmation.number.trim()}/${this.$route.params.eventId}`)
                let firstName = response.data.registration.fields.find(field => field.fieldMapping === 'firstName')
                firstName = firstName ? firstName.value : ''
                let lastName = response.data.registration.fields.find(field => field.fieldMapping === 'lastName')
                lastName = lastName ? lastName.value : ''

                if (firstName.length && firstName.toLowerCase().trim() !== this.viewConfirmation.firstName.toLowerCase().trim()) {
                    this.$notify({ type: 'danger', message: 'Confirmation not found!' })
                    return
                }
                
                if (lastName.length && lastName.toLowerCase().trim() !== this.viewConfirmation.lastName.toLowerCase().trim()) {
                    this.$notify({ type: 'danger', message: 'Confirmation not found!' })
                    return
                }
                
                this.$router.push({ name: 'welcome-email', params: { registrationId: response.data.registration._id } })
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error on viewConfirmation')
            }
        },
        getEditRegistrationLink: async function () {
            this.sendingLink = true
            try {
                await http.post(`/api/registrations/get-edit-registration-link/${this.editRegistrationMethod}`, {
                    eventId: this.$route.params.eventId,
                    email: this.editRegistrationEmail,
                    registrationId: this.editRegistrationId,
                    host: `${window.location.protocol}//${window.location.host}`
                })

                this.editRegistrationDialog = false
                this.editRegistrationEmail = ''
                this.editRegistrationId = ''
                this.$notify('Information to edit this registration successfully sent to your email.')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error sending edit registration link')
            }
            this.sendingLink = false
        },
    }
}
</script>
<style>
.field-set-block{
    padding: 16px;
    /* border: 2px solid #272626; */
    position: relative;
    margin-bottom:15px;
    background-color:rgba(255,255,255,0.8);
    border-radius:5px;
    border: 1px solid #cfd0d4;
    text-align: center;
}
.field-set-block .group-name{
    font-size: 18px;
    font-weight: 600;
    /* margin: 0; */
    position: relative;
    top: -3px;
    margin-bottom: 10px;
    color: green;
}
.field-set-block .card {
    box-shadow: 0 1px 15px 1px rgba(39, 39, 39, 0.30);
    font-weight: 600;
}
.white-text{
   color:#fff;
}
.white-text *{
   color:#fff !important;
}
.website-background-image .copyright{
    color:#fff;
}
.type-clickable{
    cursor:pointer;
    color: #2c2c2c;
    font-size: 14px;
}

.type-card{
    background: rgba(255, 255, 255, 0.748);
    border-radius: 7px;
    height: 200px;
    padding: 20px;
}
.type-wrapper{
    display: grid;
    gap: 20px;
}

@media screen and (min-width: 748px) {
    .type-wrapper{
        grid-template-columns: repeat(2, 1fr);
    }
}
@media screen and (min-width: 1200px) {
    .type-wrapper{
        grid-template-columns: repeat(3, 1fr);
    }
}
@media screen and (min-width: 1400px) {
    .type-wrapper{
        grid-template-columns: repeat(4, 1fr);
    }
}

</style>